export const ROUTES = {
  HOME: "/dashboard",
  PAYMENT_LINK: "/dashboard/payment-link",
  TRANSACTION: "/dashboard/transaction",
  SETTINGS: "/dashboard/settings",
  TOKENIZATION: "/dashboard/tokenization",
  LOGIN: "/auth/login",
};
